<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
    v-card.neutral200
      //- Top bar
      v-card-title.px-4
        v-btn.mr-2(icon color="neutral700" @click="handleCloseDialog")
          v-icon $yzi-arrow-narrow-left
        .text-2xl.font-semibold Merge Contact
        v-spacer

      v-card-text.neutral700--text
        .text-md.mb-4 Select two contact to merge. Then choose which information that you would like to keep in the contact
        v-row(no-gutters)
          // Merge selection
          v-col
            v-card.round-lg.border-color(outlined)
              merge-patient-dropdown-item(:merge-from-patient.sync="mergeFromPatient.details" :merge-into-patient.sync="mergeIntoPatient.details" :error-message="errorMessage")
              merge-item(title="Contact image" :merge-from-item="itemImageFile.mergeFrom" :merge-into-item="itemImageFile.mergeInto" is-image show-divider @change="handleItemChange('profileImage', $event)")
              merge-item(title="Name" :merge-from-item="mergeFromPatient.details.name" :merge-into-item="mergeIntoPatient.details.name" show-divider @change="handleItemChange('name', $event)")
              merge-item(title="ID number/Passport" :merge-from-item="mergeFromPatient.details.ic" :merge-into-item="mergeIntoPatient.details.ic" show-divider @change="handleItemChange('ic', $event)")
              merge-item(title="Phone number" :merge-from-item="mergeFromPatient.details.phone" :merge-into-item="mergeIntoPatient.details.phone" show-divider @change="handleItemChange('phone', $event)")
              merge-item(title="Email" :merge-from-item="mergeFromPatient.details.email" :merge-into-item="mergeIntoPatient.details.email" show-divider @change="handleItemChange('email', $event)")
              merge-item(title="Date of birth" :merge-from-item="mergeFromPatient.details.dob" :merge-into-item="mergeIntoPatient.details.dob" show-divider @change="handleItemChange('dob', $event)")
              merge-item(title="Gender" :merge-from-item="mergeFromPatient.details.gender" :merge-into-item="mergeIntoPatient.details.gender" show-divider @change="handleItemChange('gender', $event)")
              merge-item(title="Address" :merge-from-item="mergeFromPatient.details.address" :merge-into-item="mergeIntoPatient.details.address" is-address @change="handleItemChange('address', $event)")
          .mx-2
          // Merge preview
          v-col(cols="3")
            v-card.round-lg.border-color(outlined)
              .pa-4
                .text-sm.font-semibold.neutral500--text.mb-4 Contact preview
                merge-preview(v-if="canProceed" :profile-image="profileImage" :name="name" :ic="ic" :phone="phone" :email="email" :dob="dob" :gender="gender" :address="address" :life-time-value="totalLifeTimeValue" :total-visit="totalVisit")
                .text-sm(v-else)
                  span.danger500--text(v-if="errorMessage") {{ errorMessage }}
                  span(v-else) Start select info to start viewing your merged contact preview here
      v-card-actions.white.pa-0.ma-0
      .d-flex.flex-column
        v-divider
        .d-flex.justify-end.align-center.my-4.mx-8
          v-btn.button-sm.underline.mr-2(text @click="handleCloseDialog") {{ $t('cancel') }}
          v-btn.button-sm(depressed color="primary" :loading="isLoading" :disabled="!canProceed" @click="handleMergePatient") Merge
</template>

<script>
import SearchPatientDropdown from "@/components/clinic/registration/SearchPatientDropdown.vue";
import MergeItem from "@/components/clinic/patient/merge/MergeItem.vue";
import MergePatientDropdown from "@/components/clinic/patient/merge/MergePatientDropdown.vue";
import MergeItemRow from "@/components/clinic/patient/merge/MergeItemRow.vue";
import MergePatientDropdownItem from "@/components/clinic/patient/merge/MergePatientDropdownItem.vue";
import {isEmptyObject} from "@/utils";
import MergePreview from "@/components/clinic/patient/merge/MergePreview.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    MergePreview, MergePatientDropdownItem, MergeItemRow, MergePatientDropdown, SearchPatientDropdown, MergeItem
  },
  props: {
    open: {
      type: Boolean,
    },
    selectedPatient: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      mergeFromPatient: {
        isFetching: false,
        details: {},
      },
      mergeIntoPatient: {
        isFetching: false,
        details: {},
      },
      isLoading: false,
      profileImage: null,
      name: null,
      ic: null,
      phone: null,
      email: null,
      dob: null,
      gender: null,
      address: null,
    }
  },
  mounted() {
    if (this.selectedPatient) {
      this.mergeFromPatient.details = this.selectedPatient
      this.profileImage = this.selectedPatient.profile_image
      this.name = this.selectedPatient.name
      this.ic = this.selectedPatient.ic
      this.phone = this.selectedPatient.phone
      this.email = this.selectedPatient.email
      this.dob = this.selectedPatient.dob
      this.gender = this.selectedPatient.gender
      this.address = this.selectedPatient.address
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    itemImageFile() {
      const noFile = {
        file: null,
      }
      return {
        mergeFrom: isEmptyObject(this.mergeFromPatient.details) ? null : this.mergeFromPatient.details?.profile_image || noFile,
        mergeInto: isEmptyObject(this.mergeIntoPatient.details) ? null : this.mergeIntoPatient.details?.profile_image || noFile,
      }
    },
    isSelectedSamePatient() {
      if (isEmptyObject(this.mergeIntoPatient.details)) {
        return false
      }
      return this.mergeFromPatient.details?.id === this.mergeIntoPatient.details?.id
    },
    errorMessage() {
      if (this.isSelectedSamePatient) {
        return 'Cannot select the same patient'
      }
      return null
    },
    canProceed() {
      return this.mergeFromPatient.details?.id && this.mergeIntoPatient.details?.id && !this.errorMessage
    },
    totalLifeTimeValue() {
      const mergeFromLifeTimeValue = this.mergeFromPatient.details?.lifetime_value || 0
      const mergeIntoLifeTimeValue = this.mergeIntoPatient.details?.lifetime_value || 0
      return mergeFromLifeTimeValue + mergeIntoLifeTimeValue
    },
    totalVisit() {
      const mergeFromTotalVisit = this.mergeFromPatient.details?.total_visit || 0
      const mergeIntoTotalVisit = this.mergeIntoPatient.details?.total_visit || 0
      return mergeFromTotalVisit + mergeIntoTotalVisit
    },
    payload() {
      return {
        merge_from: this.mergeFromPatient.details?.id || null,
        profile_image: this.profileImage?.id || null,
        name: this.name,
        ic: this.ic || null,
        phone: this.phone || null,
        email: this.email || null,
        dob: this.dob || null,
        gender: this.gender || null,
        address: this.address?.id || null,
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    handleCloseDialog() {
      this.$emit('close')
      this.showDialog = false
    },
    handleItemChange(itemType, value) {
      this[itemType] = value
    },
    async handleMergePatient() {
      this.isLoading = true
      const endpoint = `/clinics/${this.company.slug}/patients/${this.mergeIntoPatient.details.id}/merge`
      try {
        const {data} = await this.$axios.post(endpoint, this.payload)
        this.$emit('merged', data)
        this.showMessage(['success', `${this.name} contact info has been merged successfully`])
        this.updateActivityLog(endpoint, this.payload, data, 'POST', `Merge patient from id=${this.mergeFromPatient.details.id} into id=${this.mergeIntoPatient.details.id}`, this.mergeIntoPatient.details.id, null)
        this.handleCloseDialog()
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    updateActivityLog(endpoint, payload, response, method, activity, id, objectRef) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: objectRef || null,
        activity: activity,
        raw_data: {endpoint, payload, response: response, method}
      }
      this.$axios.post('/users/logs', data)
          .catch(() => {
          })
    },
  },
}
</script>

<style scoped>
.border-color {
  border: 1px solid #EEEEEE;
}
</style>